import {
  LANDING_APP_STORE_URL,
  LANDING_PLAY_STORE_URL,
} from './storeListingUrls.ts'

/** Same store URLs and markup as the landing hero (FirstSection). */
export function LandingHeroStoreButtons() {
  return (
    <div className="download-buttons">
      <a
        href={LANDING_APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="download-btn download-btn-ios"
        aria-label="Baixar na App Store"
      >
        <span className="store-icon" aria-hidden>
          <img
            src="/images/lp/apple-logo-black.png"
            alt="App Store"
            width={22}
            height={22}
          />
        </span>
        <span className="store-lines">
          <span className="store-small">Disponível na</span>
          <span className="store-name">App Store</span>
        </span>
      </a>
      <a
        href={LANDING_PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="download-btn download-btn-android"
        aria-label="Baixar no Google Play"
      >
        <span className="store-icon" aria-hidden>
          <img
            src="/images/lp/google-play.png"
            alt="Google Play"
            width={22}
            height={22}
          />
        </span>
        <span className="store-lines">
          <span className="store-small">Disponível na</span>
          <span className="store-name">Google Play</span>
        </span>
      </a>
    </div>
  )
}
